import axios from "axios";

export default {
  methods: {
    getComboAnalistas() {
      return axios.get(this.CriarUrl({ resource: "analista/all" }));
    }
  }
};
